<template lang="pug">
content-page
	div(slot="nav")
		navigation-default
	.flow-left
		h1 {{contentpage.name}}
		ws-content(:value="contentpage.content")
			v-card(outlined)
				validation-observer(v-slot="{handleSubmit, invalid}")
					v-form( @submit.prevent="handleSubmit(submitSubscriptions)")
						v-alert(:value="alert.show" :type="alert.type" border="bottom" dismissible) {{alert.text}}
						v-card-text
							h3.mb-6 {{$t('page.panel:heading')}}
							validation-provider(v-slot="{errors, touched}" rules="email" :name="$t('newsletter:email.input.label')" slim)
								v-text-field.mb-3(required clearable outlined hide-details="auto" v-model="email" :label="$t('newsletter:email.input.label')" :error-messages="touched ? errors : []")
						v-card-actions
							v-spacer
							v-btn.gradient(type="submit" depressed color="primary" text-none dark :disabled="invalid") {{ $t('newsletter:submit') }}
	div.hidden-sm-and-down(slot="sidebar" style="max-width: 280px;")
		ad(location="sidebar").mb-6
		offers.mb-6
</template>

<script>
import gql from 'graphql-tag';
import NavigationDefault from '@/components/navigation-default';
import Content from '@dengl/common/components/content.vue';
import MetaFragment from '@/components/graphql/metaFragment.graphql';

const getPanelContentpage = gql`
	query getPanelContentpage($path: String, $fallback: String) {
		contentpage(path: $path, fallback: $fallback) {
			id
			name
			slug
			content {
				...ContentDataFragment
			}
			...MetaFragment
		}
	}
	${MetaFragment}
	${Content.fragments}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/panel',
			'de-DE': '/panel',
			'nl-BE': '/panel'
		}
	},
	components: { NavigationDefault },
	asyncData({ app, route }) {
		app.ads({ sidebar: { visible: true } });

		return app.$graphClient
			.query({
				query: getPanelContentpage,
				variables: {
					path: route.path
				},
				errorPolicy: 'all',
				fetchPolicy: 'network-only'
			})
			.then(({ data, errors }) => {
				if (!data.contentpage) {
					return app.httpError(404, null, 'panel-01', errors);
				}
				if (errors) {
					throw errors[0];
				}

				app.meta(data.contentpage.meta);
				app.breadcrumbs({
					[data.contentpage.name]: { name: 'panel' }
				});
				return data;
			})
			.catch(error => {
				return app.httpError(500, null, 'panel-02', error);
			});
	},
	data() {
		return {
			email: '',
			newsletter: {
				panel: true
			},
			alert: {
				show: false,
				type: 'info',
				text: ''
			}
		};
	},
	methods: {
		submitSubscriptions() {
			const subscription = {
				email: this.email,
				newsletters: this.newsletter
			};

			this.$graphClient
				.mutate({
					mutation: gql`
						mutation($subscription: SubscriptionInput!) {
							saveNewsletterSubscription(subscription: $subscription) {
								success
							}
						}
					`,
					errorPolicy: 'all',
					variables: {
						subscription: subscription
					}
				})
				.then(({ errors, _data }) => {
					if (errors) {
						this.alert = {
							show: true,
							type: 'error',
							text: this.$t('page.newsletter:error.while.subscribing')
						};
					} else {
						this.alert = {
							show: true,
							type: 'success',
							text: this.$t('page.newsletter:subscribed')
						};
					}
				})
				.catch(_error => {
					this.alert = {
						show: true,
						type: 'error',
						text: this.$t('page.newsletter:error.while.subscribing')
					};
				});
		}
	},
	head() {
		return {
			...this.$structuredData()
		};
	}
};
</script>
